import { FormGroup, ValidationErrors } from "@angular/forms";

export function validatePassword(form: FormGroup): ValidationErrors {
  const errors: { [key: string ]: boolean } = {};

  if (form.value.password !== form.value.password_confirmation) {
    errors.passwordsDontMatch = true;
  }

  return Object.keys(errors).length ? errors : null;
}



// WEBPACK FOOTER //
// ./src/app/shared/validators/password.validator.ts